import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import AdminLayout from './AdminLayout';
import { Row, Col, Input } from 'antd';
import * as actions from './redux/actions';
import { API } from '../../helper/api';
import TextEditor from './TextEditor';

export class Setting extends Component {
  static propTypes = {
    admin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    loading: true,
    settings : {
      "name": "",
      "legalNotice": "",
      "termsOfUsage": ""
    }
  };

  componentDidMount(){
    this.getSettings();
  }

  handleSettings(settings) {
    this.setState({ loading: false, settings: { ...this.state.settings, ...settings }})
  }

  getSettings(){
    this.setState({ loading: true })

    API.get('webconfig')
      .then(res => res.status === 200 ? this.handleSettings(res.data) : this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }))
  }

  setSettings(){

    API.msg({
      success: "Configuration sauvegardé",
      error: "Une erreur est survenue",
      loading: "Enregistrement..."
    })

    API.put('webconfig', this.state.settings)
  }

  render() {

    return (
      <AdminLayout
        title="PARAMÊTRES - CONFIGURATION GÉNÉRALE DU SITE"
        loading={this.state.loading}
        buttons={
          [{
            onClick: () => this.setSettings(),
            icon: "cloud-uplaod",
            name: "ENREGISTRER"
          }
          ]
        }
      >
         <Row>  
          <Row>
            <Col span={24}>
              <div className="bloc-admin">
                <Row>
                  <Col span={24}>
                    <h2>APPLICATION TITRE</h2>
                  </Col>
                  <Col style={{ margin: '5px 0' }} span={24}>
                    <Input 
                      placeholder="Titre du site" 
                      value={this.state.settings.name} 
                      onChange={(e) => this.handleSettings({ name: e.target.value })}/>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <Row className="bloc-admin">
            <Col span={24}>
              <h2>MENTIONS LÉGALES</h2>
            </Col>
            <Col span={24}>
              <TextEditor 
                value={ this.state.settings.legalNotice } 
                onChange={(value) => this.handleSettings({ legalNotice: value })}
                  />
            </Col>
          </Row>

          <Row className="bloc-admin">
            <Col span={24}>
              <h2>CONDITIONS GÉNÉRALES D'UTILISATION - CGU</h2>
            </Col>
            <Col span={24}>
              <TextEditor 
                value={ this.state.settings.termsOfUsage } 
                onChange={(value) => this.handleSettings({ termsOfUsage: value })}/>
            </Col>
          </Row>
        </Row>

      </AdminLayout >
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    admin: state.admin,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Setting);



// WEBPACK FOOTER //
// ./src/features/admin/Settings.js